import axios from 'axios';
import { API_URL } from '../config';

// Separate axios instance from utils/api.js — a shop-staff session and a
// Super Admin session are different identities and must never share a
// token/interceptor, otherwise one login would silently clobber the other.
const superAdminApi = axios.create({ baseURL: `${API_URL}/superadmin` });

superAdminApi.interceptors.request.use(config => {
  const token = localStorage.getItem('superadmin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

superAdminApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('superadmin_token');
      window.location.href = '/superadmin/login';
    }
    return Promise.reject(err);
  }
);

export default superAdminApi;
